import script from "./SimpleSelectInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleSelectInput.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleSelectInput.vue?vue&type=style&index=0&id=5541eff6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5541eff6"]])

export default __exports__